import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomPhoneField from "../../Layout/Common/customPhoneField";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { Fragment, useRef, useState } from "react";
import { SuccessMessageContainer } from "../../Layout/Common/alert/SuccessMessageContainer";
import { FormikErrorMessage } from "../../Layout/Common/fromikErrorMessage";
import { useProductOverlay } from "./productOverlay/productOverlayContext";

const errorMessageStyle = { fontSize: "12px", fontWeight: "bold" };
export const AskQuestionContainer = ({ familyData }) => {
  const [submitclicked, setSubmitclicked] = useState(false);
  const toastRef = useRef();
  const { sendQuestionMail } = useGlobalFunction();
  const overlay = useProductOverlay();
  const initialValues = {
    fullName: "",
    phoneNumber: "",
    question: "",
  };

  const validationSchema = Yup.object({
    fullName: Yup.string().required("Full Name is required"),
    phoneNumber: Yup.string().matches(/^\d+$/, { message: "Must be a number", excludeEmptyString: true }),
    question: Yup.string().max(300, "Maximum 300 characters").required("Question is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setSubmitclicked(true);
    try {
      var payload = {
        fileName: familyData.familyName,
        fullName: values.fullName.trim(),
        phone: values.phoneNumber,
        message: values.question,
        url: overlay?.productUrl ?? window.location.href,
      };
      let results = await sendQuestionMail(payload);
      if (results) {
        toastRef.current.showAlert(
          "Success!",
          "Thanks for your enquiry. Our Customer Sales Team will be in contact with you Shortly.",
        );
      }
    } catch (ex) {
      console.error("handleSendRequest", ex);
    }
    resetForm();
    setSubmitclicked(false);
  };

  return (
    <div className="mb-20px" id="section-questions">
      <div className="proSection-title custom-border both">
        <h4
          className="d-flex align-items-start justify-content-between"
          data-bs-toggle="collapse"
          href="#listQuestion"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
          Questions <i className="fa-solid fa-chevron-down" />
        </h4>
      </div>
      <div className="collapse" id="listQuestion">
        <div className="question-innerTitle">
          <h5>Have a Question?</h5>
          <p>
            Have a question or need clarification about this product? Fill out the form below, and we will get back to
            you shortly.
          </p>
        </div>
        {/* Inner Title */}
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ setFieldValue, errors, isValid, touched, values, resetForm, ...formik }) => (
            <Form>
              <div className="row">
                <div className="col-sm-12 col-lg-12">
                  <div className="row">
                    <div className="col-sm-6 col-lg-6">
                      <div className="row">
                        <div className="col-sm-12 col-lg-12">
                          <div className="mt-3 question-form">
                            <label htmlFor="fullName" className="form-label">
                              Full Name <span>*</span>
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              id="fullName"
                              name="fullName"
                              placeholder="Enter Full Name"
                            />
                            <ErrorMessage name="fullName" className="text-danger">
                              {(msg) => <FormikErrorMessage message={msg} />}
                            </ErrorMessage>
                          </div>

                          <div className="mt-3 question-form">
                            <label htmlFor="phoneNumber" className="form-label">
                              Phone Number
                            </label>
                            <Field
                              name="phoneNumber"
                              id="phoneNumber"
                              component={CustomPhoneField}
                              className="form-control"
                              placeholder="Enter Phone Number"
                            />

                            <ErrorMessage name="phoneNumber" className="text-danger">
                              {(msg) => <FormikErrorMessage message={msg} />}
                            </ErrorMessage>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-lg-6 questionForm-rht">
                      <div className="mt-3 question-form">
                        <label htmlFor="question" className="form-label">
                          Question <span>*</span>
                        </label>
                        <Field
                          as="textarea"
                          className="form-control"
                          id="question"
                          name="question"
                          rows={8}
                          maxLength={300}
                          placeholder="Enter Your Question"
                        />
                        <ErrorMessage name="question" className="text-danger">
                          {(msg) => <FormikErrorMessage message={msg} />}
                        </ErrorMessage>
                      </div>
                      <p>* Maximum 300 Characters</p>
                    </div>

                    <div className="col-sm-12 col-lg-12">
                      <SuccessMessageContainer ref={toastRef} />
                      <div className="proQuestion-btn">
                        <div className="product-button button-effect">
                          <button
                            type="submit"
                            className="btn btn-products theme-primary"
                            disabled={submitclicked == true && "disabled"}
                          >
                            {submitclicked == true ? (
                              <Fragment>
                                <i className="fas fa-spinner fa-spin"></i> Sending...
                              </Fragment>
                            ) : (
                              "Send Mail"
                            )}
                          </button>
                        </div>
                        <div className="product-button">
                          <button type="button" className="btn btn-products btn-unavailable" id="cancelQts-proDownload">
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
